(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[1595],{

/***/ 61595:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Content083": function() { return /* binding */ Content083; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(94184);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var shared_components__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(87900);
/* harmony import */ var shared_hooks__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(87367);
/* harmony import */ var shared_utils__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(63414);
/* harmony import */ var _Content083_module_scss__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(95921);
/* harmony import */ var _Content083_module_scss__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(_Content083_module_scss__WEBPACK_IMPORTED_MODULE_5__);






var Content083 = function(param) {
    var payload = param.payload;
    var ref;
    var ref1;
    var title = (ref1 = payload === null || payload === void 0 ? void 0 : payload.title) !== null && ref1 !== void 0 ? ref1 : "";
    var ref2;
    var description = (ref2 = payload === null || payload === void 0 ? void 0 : payload.description) !== null && ref2 !== void 0 ? ref2 : "";
    var ref3;
    var position = (ref3 = payload === null || payload === void 0 ? void 0 : payload.position) !== null && ref3 !== void 0 ? ref3 : "left";
    var ref4;
    var ref5 = (ref4 = payload === null || payload === void 0 ? void 0 : payload.person) !== null && ref4 !== void 0 ? ref4 : {}, fullName = ref5.fullName, labelText = ref5.labelText, role = ref5.role;
    var ref6;
    var image = (ref6 = payload === null || payload === void 0 ? void 0 : (ref = payload.person) === null || ref === void 0 ? void 0 : ref.preview) !== null && ref6 !== void 0 ? ref6 : {};
    var ref7;
    var ref8 = (ref7 = payload === null || payload === void 0 ? void 0 : payload.button) !== null && ref7 !== void 0 ? ref7 : {}, buttonText = ref8.buttonText, videoLink = ref8.videoLink;
    var videoId = (0,shared_utils__WEBPACK_IMPORTED_MODULE_4__/* .parseYouTubeId */ .Us)(videoLink);
    var ref9 = (0,shared_hooks__WEBPACK_IMPORTED_MODULE_3__/* .useToggle */ .OT)(), opened = ref9.opened, onOpen = ref9.onOpen, onClose = ref9.onClose;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        className: (_Content083_module_scss__WEBPACK_IMPORTED_MODULE_5___default().wrapper),
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(shared_components__WEBPACK_IMPORTED_MODULE_2__/* .Container */ .W2, {
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                className: classnames__WEBPACK_IMPORTED_MODULE_1___default()((_Content083_module_scss__WEBPACK_IMPORTED_MODULE_5___default().block), (_Content083_module_scss__WEBPACK_IMPORTED_MODULE_5___default())[position]),
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                        className: (_Content083_module_scss__WEBPACK_IMPORTED_MODULE_5___default().content),
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(shared_components__WEBPACK_IMPORTED_MODULE_2__/* .Heading5 */ .by, {
                                        className: (_Content083_module_scss__WEBPACK_IMPORTED_MODULE_5___default().title),
                                        color: "brand",
                                        children: title
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(shared_components__WEBPACK_IMPORTED_MODULE_2__/* .Heading6 */ .Cd, {
                                        className: (_Content083_module_scss__WEBPACK_IMPORTED_MODULE_5___default().description),
                                        color: "dark",
                                        children: description
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                className: (_Content083_module_scss__WEBPACK_IMPORTED_MODULE_5___default().person),
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(shared_components__WEBPACK_IMPORTED_MODULE_2__/* .ImageLite */ .NH, {
                                        image: image,
                                        className: (_Content083_module_scss__WEBPACK_IMPORTED_MODULE_5___default().image)
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                        children: [
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                                className: (_Content083_module_scss__WEBPACK_IMPORTED_MODULE_5___default()["person-details"]),
                                                children: [
                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(shared_components__WEBPACK_IMPORTED_MODULE_2__/* .Paragraph */ .nv, {
                                                        color: "dark",
                                                        appearance: "bigger",
                                                        className: (_Content083_module_scss__WEBPACK_IMPORTED_MODULE_5___default().name),
                                                        children: fullName
                                                    }),
                                                    labelText && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(shared_components__WEBPACK_IMPORTED_MODULE_2__/* .Paragraph */ .nv, {
                                                        color: "light",
                                                        appearance: "bigger",
                                                        className: (_Content083_module_scss__WEBPACK_IMPORTED_MODULE_5___default().label),
                                                        children: labelText
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(shared_components__WEBPACK_IMPORTED_MODULE_2__/* .Paragraph */ .nv, {
                                                color: "grey",
                                                className: (_Content083_module_scss__WEBPACK_IMPORTED_MODULE_5___default().role),
                                                children: role
                                            })
                                        ]
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                        className: (_Content083_module_scss__WEBPACK_IMPORTED_MODULE_5___default().action),
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(shared_components__WEBPACK_IMPORTED_MODULE_2__/* .Action */ .aU, {
                                onClick: onOpen,
                                className: (_Content083_module_scss__WEBPACK_IMPORTED_MODULE_5___default().button),
                                disabled: !videoId,
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                        className: (_Content083_module_scss__WEBPACK_IMPORTED_MODULE_5___default().play),
                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(shared_components__WEBPACK_IMPORTED_MODULE_2__/* .Icon */ .JO, {
                                            className: (_Content083_module_scss__WEBPACK_IMPORTED_MODULE_5___default().icon),
                                            name: "play",
                                            theme: "white"
                                        })
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(shared_components__WEBPACK_IMPORTED_MODULE_2__/* .Paragraph */ .nv, {
                                        color: "brand",
                                        appearance: "bigger",
                                        className: (_Content083_module_scss__WEBPACK_IMPORTED_MODULE_5___default()["button-text"]),
                                        children: buttonText
                                    })
                                ]
                            }),
                            opened && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(shared_components__WEBPACK_IMPORTED_MODULE_2__/* .ModalWrapper */ .AB, {
                                onCloseModal: onClose,
                                appearance: "full-area",
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(shared_components__WEBPACK_IMPORTED_MODULE_2__/* .YoutubeVideo */ .tL, {
                                    id: videoId
                                })
                            })
                        ]
                    })
                ]
            })
        })
    });
};
/* harmony default export */ __webpack_exports__["default"] = (Content083);


/***/ }),

/***/ 95921:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"Content083_wrapper__VMTV6","block":"Content083_block__Q6wgW","content":"Content083_content__nFmoh","left":"Content083_left__kiru3","right":"Content083_right__BYAcG","action":"Content083_action__HAL1y","title":"Content083_title__M8NaK","description":"Content083_description__h3ENx","person":"Content083_person__gRbmx","person-details":"Content083_person-details__89iJ2","label":"Content083_label__qsOIp","role":"Content083_role__qXX9B","name":"Content083_name__St0i9","image":"Content083_image__rUbeM","button":"Content083_button__9Rnyt","play":"Content083_play__pc2X9","icon":"Content083_icon__dYjEO","button-text":"Content083_button-text__D1n6e"};

/***/ })

}]);